/** Шаги линейки ОГЭ · Программирование. quizTitle совпадает с названием теста в базе. */

export const OGE_PYTHON_PATH_SLUG = 'osnovy_python_oge';

export const OGE_PYTHON_STEPS = [
  {
    id: 'interface',
    title: 'Как запустить программу',
    lead: 'Тот же экран, что в ЕГЭ: редактор, вывод, Ctrl+Enter.',
    konspekts: [{ slug: 'osnovy-01-interfejs', title: 'Интерфейс сайта' }],
  },
  {
    id: 'print',
    title: 'print и вычисления',
    lead: 'Программа печатает и считает, переменных ещё нет.',
    konspekts: [{ slug: 'oge-py-01-print', title: 'Конспект' }],
    quizTitle: 'ОГЭ · Вывод и арифметика',
    writeTag: 'oge-print',
  },
  {
    id: 'int',
    title: 'Переменные: числа',
    lead: 'Целое в коробке с именем. Знак = значит «положить».',
    konspekts: [{ slug: 'oge-py-02-int', title: 'Конспект' }],
  },
  {
    id: 'str',
    title: 'Переменные: текст',
    lead: 'Строки, склейка и чем текст отличается от числа.',
    konspekts: [{ slug: 'oge-py-03-str', title: 'Конспект' }],
    quizTitle: 'ОГЭ · Переменные',
    writeTag: 'oge-peremennye',
  },
  {
    id: 'input',
    title: 'Ввод input',
    lead: 'input() всегда даёт строку. Для чисел нужен int.',
    konspekts: [{ slug: 'oge-py-04-input', title: 'Конспект' }],
    quizTitle: 'ОГЭ · Ввод',
    writeTag: 'oge-vvod',
  },
  {
    id: 'if',
    title: 'Условие if',
    lead: 'Один вопрос «да или нет», else и чётность.',
    konspekts: [{ slug: 'oge-py-05-if', title: 'Конспект' }],
    quizTitle: 'ОГЭ · Условие if',
    writeTag: 'oge-if',
  },
  {
    id: 'logic',
    title: 'and, or, not',
    lead: 'Два условия сразу, хотя бы одно, наоборот.',
    konspekts: [{ slug: 'oge-py-06-and-or-not', title: 'Конспект' }],
    quizTitle: 'ОГЭ · and, or, not',
    writeTag: 'oge-logika',
  },
  {
    id: 'elif',
    title: 'elif и вложенный if',
    lead: 'Несколько веток и второй вопрос после первого «да».',
    konspekts: [{ slug: 'oge-py-07-elif', title: 'Конспект' }],
    quizTitle: 'ОГЭ · elif и вложенный if',
    writeTag: 'oge-elif',
  },
  {
    id: 'oge6',
    title: 'Задание 6',
    lead: 'Несколько запусков: сколько раз YES или NO. Программу писать не нужно.',
    konspekts: [{ slug: 'oge-py-08-zadanie-6', title: 'Конспект' }],
    quizTitle: 'ОГЭ · Задание 6',
  },
];
